import React from 'react';
import {Image} from '@rn-vui/themed';

import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AirtableHomepageItem} from '../../models/airtable';
import {logger} from '../../utils/logger';
import {openPageLink} from '../../utils/navigation';

import {formatHeroImage} from './shared';

interface BannerProps {
  bannerItem?: AirtableHomepageItem;
}

const Banner: React.FC<BannerProps> = ({bannerItem}) => {
  if (!bannerItem) {
    return null;
  }

  const handlePress = () => {
    if (bannerItem.pageLink) {
      openPageLink(bannerItem.pageLink);
    }
  };

  return <ResponsiveImage item={bannerItem} onPress={handlePress} />;
};

const ResponsiveImage = ({
  item,
  onPress,
}: {
  item: AirtableHomepageItem | undefined;
  onPress: () => void;
}) => {
  const {isWebDesktopScreen, platform} = useWebScreenDimensions();
  const src = formatHeroImage(item, isWebDesktopScreen);

  if (item?.platform && item.platform.length >= 1 && !item.platform.includes(platform)) {
    return null;
  }

  if (!src.uri) {
    logger.warn(
      'HomepageBanner',
      `AirtableHomepageItem.heroImage${isWebDesktopScreen && 'Web'} is empty`,
      {isWebDesktopScreen},
    );
    return null;
  }

  return (
    <Image
      onPress={onPress}
      source={src}
      containerStyle={{
        width: '100%',
        aspectRatio: !isWebDesktopScreen
          ? item?.heroImage?.width && item.heroImage.height
            ? item?.heroImage?.width / item?.heroImage?.height
            : 1.54
          : item?.heroImageWeb?.width && item.heroImageWeb.height
            ? item.heroImageWeb.width / item.heroImageWeb.height
            : 1.54,

        flex: 1,
        flexGrow: 1,
        borderRadius: 10,
        ...(isWebDesktopScreen
          ? {
              maxHeight: item?.heroImageWeb?.height,
            }
          : {}),
      }}
    />
  );
};

export default Banner;
